import type { IntlShape } from "@formatjs/intl";
import { Form, Select } from "antd";
import type { DefaultOptionType } from "antd/es/cascader";
import type { FilterFunc } from "rc-select/lib/Select";
import { useMemo } from "react";
import type { Materials } from "../../generated-axios-client";

const materialSelectOptions = (items: Materials[]) =>
  items.map((item) => ({
    key: item.id,
    value: item.id,
    label: item.name,
  }));

const searchHandler: FilterFunc<DefaultOptionType> = (input, option) =>
  (option?.label?.toString().toLowerCase() ?? "").includes(input.toLowerCase());

type Props = {
  intl: IntlShape;
  materialItems: Materials[];
};

export const MaterialsSelectorFormItem = ({ intl, materialItems }: Props) => {
  const options = useMemo(() => materialSelectOptions(materialItems), [materialItems]);

  return (
    <Form.Item
      name="materials"
      label={intl.formatMessage({ id: "ticket_section_supplies" })}
    >
      <Select
        mode="multiple"
        options={options}
        filterOption={searchHandler}
        placeholder={intl.formatMessage({ id: "ticket_supplies_select_placeholder" })}
        allowClear
      />
    </Form.Item>
  );
};
